import { useAllCategoriesQuery } from "../../store/services/categoryService";
import Skeleton from "../skeleton/Skeleton";
import Thumbnail from "../skeleton/Thumbnail";
import CategoryCard from "./CategoryCard";

const Categories = () => {
  const { data, isFetching } = useAllCategoriesQuery();

  if (isFetching) {
    return (
      <div className="category-grid-skeleton">
        {[1, 2, 3, 4].map((item) => (
          <div className="category-skeleton" key={item}>
            <Skeleton>
              <Thumbnail height="120px" />
            </Skeleton>
          </div>
        ))}
      </div>
    );
  }

  const categories = data?.categories || [];

  if (!categories.length) return null;

  return (
    <div className={`categories-grid categories-count-${categories.length}`}>
      {categories.map((category, index) => {
        const imageIndex = (index % 4) + 1;

        return (
          <CategoryCard
            key={category._id || category.id || index}
            category={category}
            imageIndex={imageIndex}
            index={index}
            total={categories.length}
          />
        );
      })}
    </div>
  );
};

export default Categories;
